// importando estilização do botão
import { useEffect, useState } from 'react'
import style from './FormStyle.module.css'

interface IFormInput {
  nome: string | undefined;
  placeholder: string | undefined;
  change: (text: string) => void;
  viewName: boolean;
  errorMessage: string;
  value?: string;
}

export const FormInput: React.FC <IFormInput> = (data) =>{ 
    
  const [viewName, setViewName] = useState<boolean>(data.viewName);
  const [inputValue, setInputValue] = useState<string>(data.value || '');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setViewName(data.viewName);
  },[data.viewName]);

  useEffect(() => {
    if(data.value !== undefined) {
      setInputValue(data.value);
    }
  }, [data.value]);

  useEffect(() => {
    if(data.errorMessage){
      setErrorMessage(data.errorMessage);
    }else{
      setErrorMessage('');
    }
  } ,[data.errorMessage]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessage('');
    setInputValue(event.target.value);
    data.change(event.target.value);    
  }

  return (       
    // aqui dentro vamos colocar nosso JSX     
    <div className={style.ContentFormInput}>
        {viewName ? ( 
        <div className={style.inputName}>
          <span>{data.nome}</span>
        </div>
        ):null}
        <div className={style.inputText}>
            <input type="text" placeholder={data.placeholder} value={inputValue} onChange={handleChange}/>
        </div>        
        {errorMessage ?(
        <div className={style.ErrorMessage}>
            <span>{errorMessage}</span>
        </div> 
        ):null}
    </div>                
  )
}


